import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = () => {
  const isLogged = useSelector((state) => state.isLogged)
  const ACCtoken = useSelector((state) => state.ACCtoken)
  const location = useLocation()

  // If user is not authenticated, redirect to signin page with "next" parameter
  if (ACCtoken === 0 || !isLogged) {
    return (
      <Navigate
        to={`/signin?next=${encodeURIComponent(location.pathname)}`}
        replace
      />
    )
  }

  // If authenticated, render the protected route
  return <Outlet />
}

export default PrivateRoute